import { call } from 'redux-saga/effects'
import { APIS } from '../../_config'
import { CallApi } from '../api/callApi'
import { ErrorResponse, SuccessResponse } from '../api/apiTypes'
import { trackError } from '../../utils/analytics/rumTracking'

export function* getSelfServiceDropDown<P, R>(action: { type: string; payload: any; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.SELFSERVICE.SELF_SERVICE_DROPDOWN(action.payload.literal), action.payload, false)
        if (resp?.data?.success) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        action?.onError({ message: e.message, status_code: 400, success: false })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getSelfServiceDropDown', action: action?.type })
    }
}

export function* getSelfServiceData<P, R>(action: { type: string; payload: any; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.SELFSERVICE.SELF_SERVICE_DATA(action.payload.literal), action.payload, false)
        if (resp?.data?.success) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        action?.onError({ message: e.message, status_code: 400, success: false })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getSelfServiceData', action: action?.type })
    }
}

export function* saveSelfServiceData<P, R>(action: { type: string; payload: any; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        if (!action?.payload?.literal) {
            throw new Error('Invalid payload: Missing required fields')
        }
        const resp = yield call(CallApi.GET, APIS.SELFSERVICE.SAVE_SELFSERVICE_DATA(action.payload.literal), action.payload, false)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        action?.onError({ message: e.message ?? 'An unexpected error occurred', status_code: e.status ?? 400, success: false })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'saveSelfServiceData', action: action?.type })
    }
}

export function* getSelfServiceDataColumn<P, R>(action: { type: string; payload: any; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(
            CallApi.GET,
            APIS.SELFSERVICE.GET_SELF_SERVICE_DATA_COLUMN(action.payload.literal, action.payload.column_name),

            action.payload,
            false,
        )
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        action?.onError({ message: e.message, status_code: 400, success: false })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getSelfServiceDataColumn', action: action?.type })
    }
}
